import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";

/**
 * Outer container — Figma spec:
 *   border 1px stroke/200, radius 12px,
 *   drop-shadow 1px 1px 3px rgba(89,98,112,0.1),
 *   padding 8px 12px 12px 12px, flex-col gap 16px.
 *
 * No separator line below the header — the `gap` does the visual work,
 * and the inner table carries its own border for nested chrome.
 */
export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};
  background-color: ${({ theme }) => theme.colors.surface.primary};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${({ theme }) => theme.borders.radius.xl};
  box-shadow: 1px 1px 3px rgba(89, 98, 112, 0.1);
  padding: ${spacing[2]} ${spacing[3]} ${spacing[3]};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[3]};
`;

export const TitleButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[2]};
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.primary};
  ${typographyMixin("subtitle", 2)}

  &:focus-visible {
    outline: ${({ theme }) => theme.borders.width[2]} ${({ theme }) =>
  theme.borders.style.solid} ${rawColors.primary[500]};
    outline-offset: ${spacing[1]};
    border-radius: ${({ theme }) => theme.borders.radius.sm};
  }
`;

export const HeaderActions = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[2]};
`;

/**
 * Right-side cluster: action button(s) + chevron toggle. 16px gap matches
 * Figma's `gap-[16px]` between Edit-dataset and the chevron.
 */
export const RightCluster = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[4]};
`;

/**
 * Chevron toggle button — visual icon button on the right side of the
 * header. Clicking toggles `expanded`. `aria-expanded` is set on it.
 */
export const ChevronButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.primary};

  &:focus-visible {
    outline: ${({ theme }) => theme.borders.width[2]} ${({ theme }) =>
  theme.borders.style.solid} ${rawColors.primary[500]};
    outline-offset: ${spacing[1]};
    border-radius: ${({ theme }) => theme.borders.radius.sm};
  }
`;

/**
 * Body — no separator and no padding. The inner consumer (e.g. TableCard
 * inside ConnectedDatasetSection) provides its own bordered surface.
 */
export const Body = styled.div`
  display: block;
`;
